const LETTERS_LENGTH = 4;
const NUMBERS_LENGTH = 4;

const getRandomUpperLetter = () =>
  String.fromCharCode('A'.charCodeAt(0) + Math.floor(Math.random() * 26));

const getRandomDigits = (length: number) => {
  const num = Math.floor(Math.random() * 10 ** length);
  return num.toString().padStart(length, '0');
};

const buildLettersPart = (text: string) => {
  const words = text.trim().split(/\s+/).filter(Boolean);

  if (!words.length) {
    return Array.from({ length: LETTERS_LENGTH }, () => getRandomUpperLetter()).join('');
  }

  const firstLetters = words.map((w) => w[0]?.toUpperCase());

  if (firstLetters.length >= LETTERS_LENGTH) {
    return firstLetters.slice(0, LETTERS_LENGTH).join('');
  }

  const firstLastLetters: string[] = [];
  words.forEach((w) => {
    const trimmed = w.trim();
    if (!trimmed) return;
    const first = trimmed[0]?.toUpperCase();
    const last = trimmed[trimmed.length - 1]?.toUpperCase();
    firstLastLetters.push(first);
    if (firstLastLetters.length < LETTERS_LENGTH) {
      firstLastLetters.push(last);
    }
  });

  const letters = firstLastLetters.slice(0, LETTERS_LENGTH);

  while (letters.length < LETTERS_LENGTH) {
    letters.push(getRandomUpperLetter());
  }

  return letters.join('');
};

export const getCompanyCode = (text: string) => {
  const lettersPart = buildLettersPart(text);
  const numbersPart = getRandomDigits(NUMBERS_LENGTH);

  return `${lettersPart}${numbersPart}`;
};
